// SCRIPTS DO ESPECIAL
function modal_timeline() {

    $("button[data-timeline], a[data-timeline]").on('click', function(event) {
        event.preventDefault();

        var id = "#" + $(this).data("timeline"),
            $closeModal = $(".btn-close-modal"),
            $body = $(this).parents("body");

        $(id).addClass('active');
        $body.addClass('show-modal2');

        var iframe = $(id).find('iframe');
        if(iframe.length){
            var src = iframe.attr('src');
            if(src && src.indexOf('autoplay=0') > -1){
                src = src.replace('autoplay=0', 'autoplay=1');
                iframe.attr('src', src);
            }
        }

        if ($body.hasClass('show-modal2')) {
            $closeModal.on('click', function(event) {
                event.preventDefault();
                $body.removeClass('show-modal');
                $(id).removeClass('active');
                if(iframe.length){
                    var src = iframe.attr('src');
                    if(src){
                        src = src.replace('autoplay=1', 'autoplay=0');
                        iframe.attr('src', src);
                    }
                }
            });
        }
    });

    $(document).on('click', '.modal-default', function(event) {
        if (!$(event.target).parents('.modal-default').length) {
            close($(event.target));
        }
        event.preventDefault();
    });

    function close(el) {
        $(".modal-default").removeClass('active');
        $("body").removeClass('show-modal');
        if(el){
            var iframe = el.find('iframe');
            var src = iframe.attr('src');
            if(iframe && src ) {
                src = src.replace('autoplay=1', 'autoplay=0');
                iframe.attr('src', src);
            }
        }
    }
}


$(document).ready(function() {
    // OWL CAROUSEL
    $('.owl-carousel').owlCarousel({
        center: true,
        items:1,
        loop:true,
        nav:true,
        dots: false,
        margin:30,
        responsive:{
            600:{
                items:1
            }
        }
    });

    if(window.screen.width <= 767){
        var swiper = new Swiper('.depoimentos', {
            slidesPerView: 'auto',
            spaceBetween: 0,
            scrollbar: '.depoimentos .swiper-scrollbar',
            scrollbarHide: false,
            scrollbarDraggable: true
        });
    }

    var swiper = new Swiper('.lt-varig', {
        slidesPerView: 'auto',
        spaceBetween: 0,
        scrollbar: '.lt-varig .swiper-scrollbar',
        speed: 1000,
        parallax: true,
        scrollbarHide: true,
        scrollbarDraggable: true
    });

    var swiper = new Swiper('.lt-vasp', {
        slidesPerView: 'auto',
        spaceBetween: 0,
        scrollbar: '.lt-vasp .swiper-scrollbar',
        speed: 1000,
        parallax: true,
        scrollbarHide: true,
        scrollbarDraggable: true
    });

    var swiper = new Swiper('.lt-transbrasil', {
        slidesPerView: 'auto',
        spaceBetween: 0,
        scrollbar: '.lt-transbrasil .swiper-scrollbar',
        speed: 1000,
        parallax: true,
        scrollbarHide: true,
        scrollbarDraggable: true
    });

    $('.tooltip-frase').click(function(e){
        $(this).parent().find('.tooltipcontent').css('visibility', 'visible');
    });

    $('.tooltip-close').click(function(e){
        $(this).parent().css('visibility', 'hidden');
    });

    modal_timeline();
});
